<form [formGroup]="form" id="form_e0164ddb">
  <span
    class="p-float-label trm-filter-dropdown"
    [ngSwitch]="displayAs"
    id="span_p-float-label_69e0dbf3"
  >
    <ng-container *ngSwitchCase="'dropdown'" id="ng-container_e30ef81c">
      <p-autoComplete
        id="autoComplete-dropdown"
        [suggestions]="suggestions"
        [formControl]="control"
        [dropdown]="true"
        [completeOnFocus]="true"
        [styleClass]="allStyleClass"
        [field]="displayProperty"
        (completeMethod)="setFilter($event)"
        (onLazyLoad)="setFilter($event)"
        (onSelect)="select($event)"
      >
        <ng-template
          let-option=""
          pTemplate="item"
          let-i="index"
          id="ng-template_b0b9cef5"
        >
          <span id="span_e2374ed3">{{
            !!displayProperty ? option[displayProperty] : option
          }}</span>
        </ng-template>
      </p-autoComplete>
      <label class="label" for="autoComplete" id="label_label_a2ad3d93">{{
        label
      }}</label>
      <span
        *ngIf="required && this.control.invalid"
        class="required-txt"
        id="span_required-txt_837be996"
        >Required Field</span
      >
    </ng-container>
    <ng-container *ngSwitchCase="'CarType'" id="ng-container_4584b9df">
      <p-dropdown
        id="dropdown-cartype"
        [formControl]="control"
        [placeholder]="' '"
        [options]="filter.values"
        [optionLabel]="displayProperty"
        (onChange)="selectDropdown($event)"
        [styleClass]="allStyleClass"
        optionDisabled="inactive"
      ></p-dropdown>
      <label
        class="label"
        [ngClass]="filter.displayAs === 'range' ? 'range' : ''"
        or="dropdown"
        id="label_label_9bbbf3a5"
        >{{ label }}</label
      >
    </ng-container>
    <ng-container *ngSwitchCase="'input'" id="ng-container_1393948e">
      <label
        [ngClass]="required && this.control.invalid ? 'required-label' : ''"
        class="label input-label"
        for="input"
        id="label_label_7af1cad5"
        >{{ label }}</label
      >
      <input
        id="product-name"
        class="'tms-product-name'"
        [formControl]="control"
        type="text"
        pInputText=""
        [placeholder]="'Enter Product Name'"
        (change)="selectInput()"
        autocomplete="off"
      />
      <span
        *ngIf="required && this.control.invalid"
        class="required-txt"
        id="span_required-txt_47c9ce77"
        >Required Field</span
      >
    </ng-container>
  </span>
</form>
